import { Box, CircularProgress } from '@mui/material';
import { privilegeTypeEnum } from '../../../assets/js/utils';
import EmptyCard from '../../../components/ui/EmptyCard';
import { useGetNewsList } from '../../../hooks/useNews';
import PrivilegeGroup from './PrivilegeGroup';
import PrivilegeItem from './PrivilegeItem';

const PrivilegeList = () => {
  const { data: newsData, isLoading } = useGetNewsList();
  const newsList = newsData?.Data?.data || [];

  const renderPrivilegeList = (lists) => {
    if (lists.length > 0) {
      return lists.map((item) => {
        if (item.type === privilegeTypeEnum.GROUP) {
          return (
            <PrivilegeGroup
              type={item.type}
              key={item?._id}
              id={item?._id}
              topic={item?.topic}
              children={item?.data}
              banner={item?.image_url}
              index={item?.index}
            />
          );
        }

        if (item.type === privilegeTypeEnum.CARD) {
          return (
            <PrivilegeItem
              type={item.type}
              key={item?._id}
              id={item?._id}
              topic={item?.topic}
              img={item?.image_url}
              url={item?.external_url}
              detail={item?.detail}
              index={item?.index}
            />
          );
        }

        return [];
      });
    } else {
      if (isLoading) {
        return;
      }

      return <EmptyCard text="ไม่พบข่าวสาร" />;
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={1} sx={{ padding: '20px 16px 60px' }}>
      {isLoading && (
        <CircularProgress thickness={5} sx={{ display: 'block', margin: '20px auto' }} />
      )}
      {renderPrivilegeList(newsList)}
    </Box>
  );
};

export default PrivilegeList;
